// extracted by mini-css-extract-plugin
export default {"NewTabModal":"newTabForm__NewTabModal__qnW0N","ErrorMessage":"newTabForm__ErrorMessage__g2u56","RadioGroup":"newTabForm__RadioGroup__mIu3Z"};